import { SelectionModel } from '@angular/cdk/collections';
import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { ConfigurationService } from '../../configuration.service';
import { TimeConfig } from '../../dashboard-config.model';

@Component({
  selector: 'app-search-time-config',
  templateUrl: './search-time-config.component.html',
  styleUrls: ['./search-time-config.component.scss']
})
export class SearchTimeConfigComponent implements OnInit {

  dataSource = new MatTableDataSource<TimeConfig>();
  selection = new SelectionModel<any>(true, []);
  displayedColumns: string[] = ['timeIntervalA', 'timeIntervalAColor', 'timeIntervalB', 'timeIntervalBColor', 'timeIntervalC', 'timeIntervalCColor'];
  constructor(public dialog: MatDialog, public configurationService: ConfigurationService) { }

  ngOnInit(): void {
    this.getTimeList();
  }

  getTimeList() {
    this.configurationService.getTimeConfig().subscribe(data => {
      this.dataSource.data = data;
    });
  }


  isAllSelected() {
    const numSelected = this.selection.selected.length;
    const numRows = this.dataSource.data.length;
    return numSelected === numRows;
  }

  masterToggle() {
    this.isAllSelected() ?
      this.selection.clear() :
      this.dataSource.data.forEach(row => this.selection.select(row));
  }

  selectRow(row) {
    this.selection.toggle(row);
    this.configurationService.selectedTimeConfigData = row;
    this.dialog.closeAll();
  }

  closedialog() {
    this.dialog.closeAll();
  }
}
